import { createSelector } from 'reselect';

const rootSelector = state => state.app.global;

export const selectProperty = createSelector(
  rootSelector,
  subState => subState.property
);
